import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import { getConfigClientFromRTE } from '@src/app/core/config/config-client';
import { merge } from 'lodash';
import { storeFreeze } from 'ngrx-store-freeze';
import { localStorageSync } from 'ngrx-store-localstorage';

function getSavedState(localStorageKey: string): any {
  return JSON.parse(localStorage.getItem(localStorageKey));
}

// Cypress testing : the local storage key to pull the state object from
const key = '__app_storage__';

export function storageMetaReducer<S, A extends Action = Action>(reducer: ActionReducer<S, A>) {
  return function (state: S, action: A): S {
    const nextState = reducer(state, action);

    // @ts-ignore
    if (window.Cypress) {
      const savedState = getSavedState(key);
      merge(nextState, savedState);
    }
    return nextState;
  };
}

export function sessionStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  const isProd = getConfigClientFromRTE().isProduction;
  const sessionKeys = ['triage', 'internalTransfer', 'costBasis'];
  const satOnlyKeys = [];
  const keys = isProd ? [...sessionKeys] : [...sessionKeys, ...satOnlyKeys];
  return localStorageSync({
    keys: keys,
    rehydrate: true,
    removeOnUndefined: false,
    storage: sessionStorage,
  })(reducer);
}

export const metaReducers: MetaReducer<any>[] = [
  storeFreeze,
  storageMetaReducer,
  sessionStorageSyncReducer,
];
